export default __webpack_public_path__ + "static/media/logo-white.f4ffcbae.svg";